<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Настройки звука открытия двери</v-list-item-title>
      <v-list-item-subtitle class="text-wrap mt-1">
        Быстрая загрузка по выбранным в таблице.
        <a href="#" class="primary--text" @click.prevent="$emit('redirect-new-page')">Расширенная страница</a>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="dialogSound" max-width="560">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            Настройки звука открытия двери
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  text
                  x-large
                  class="btn__icon pa-0"
                  width="18"
                  height="18"
                  @click="dialogSound = false"
                >
                  <v-icon size="x-large">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Закрыть</span>
            </v-tooltip>
          </v-card-title>
          <v-form
            ref="formSoundDoorphone"
            v-model="validSound"
            lazy-validation
          >
            <v-row class="ma-3 mb-0">
              <v-col
                v-if="$checkPermission('upload_open_door_sound_doorphone')"
                cols="9"
                class="py-0"
              >
                <v-file-input
                  ref="soundDoor"
                  v-model="soundDoorOpening"
                  accept=".wav"
                  outlined
                  dense
                  flat
                  label="Установление аудизаписи"
                  append-icon="mdi-information-outline"
                  @click:append="infoSoundDoor = !infoSoundDoor"
                ></v-file-input>
                <v-col
                  v-if="infoSoundDoor"
                  class="ml-5 pt-0"
                >
                  <p>Формат файла: wav. Размер: до 200 КБ.</p>
                  <p>Частота дискретизации: 16000 Гц. Бит: 16</p>
                </v-col>
              </v-col>
              <v-col
                v-if="$checkPermission('upload_open_door_sound_doorphone')"
                cols="2"
                class="py-0"
              >
                <v-btn
                  color="success"
                  class="text-none"
                  :disabled="soundDoorOpening === null || !isScheduleReady"
                  :loading="isLoading"
                  @click="changeSoundDoor()"
                >
                  Загрузить
                </v-btn>
              </v-col>
              <v-col cols="12" class="py-0">
                <mass-schedule-fields v-model="schedule" />
              </v-col>
              <v-col
                cols="9"
                class="py-0"
              >
                <p>Сброс звука открытия двери</p>
              </v-col>
              <v-col
                v-if="$checkPermission('upload_open_door_sound_doorphone')"
                cols="2"
                class="py-0"
              >
                <v-btn
                  color="primary"
                  class="text-none mb-3"
                  dark
                  :loading="loadingReset"
                  @click="reset()"
                >
                  Сбросить
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="updateResult && updateResult.message">
              <h3>{{ updateResult.message }}</h3>
            </v-col>
            <v-col v-else-if="issetRightDoorphones()">
              <h3>Успешно изменён на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.right_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
            <v-col v-else-if="issetFailDoorphones()">
              <h3>Не удалось изменить на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.fail_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';
import MassScheduleFields from '@/components/massFunction/components/MassScheduleFields.vue';
import { buildSchedulePayload } from '@/components/massFunction/utils/schedulePayload';
import { getOpenDoorSoundModelKey } from '@/components/massFunction/utils/openDoorSoundModelKey';

export default {
  name: 'SoundSettingsDoorOpening',
  components: { MassScheduleFields },
  props: ['doorphones'],
  data () {
    return {
      validSound: true,
      dialogSound: false,
      infoSoundDoor: false,
      loadingReset: false,
      soundDoorOpening: null,
      dialogResult: false,
      updateResult: {},
      isLoading: false,
      schedule: {
        useSchedule: false,
        startDate: '',
        endDate: '',
      },
    };
  },
  watch: {
    dialogSound (open) {
      if (open) {
        this.resetSchedule();
      }
    },
  },
  computed: {
    isScheduleReady () {
      if (!this.schedule || !this.schedule.useSchedule) return true;
      return !!(this.schedule.startDate && this.schedule.endDate);
    },
  },
  methods: {
    ...mapActions({
      openDoorSoundReset: 'Doorphone/openDoorSoundReset',
      uploadOpenDoorSound: 'Doorphone/uploadOpenDoorSound',
    }),
    issetRightDoorphones () {
      return this.updateResult.right_doorphones && this.updateResult.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.updateResult.fail_doorphones && this.updateResult.fail_doorphones.length > 0;
    },
    async reset () {
      this.loadingReset = true;
      const selectedDoorphoneId = this.doorphones.map(doorphone => doorphone.id);
      await this.openDoorSoundReset({
        doorphones: selectedDoorphoneId,
      })
        .then(() => {
          this.dialogSound = false;
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch((e) => {
          const status = e?.response?.status;
          const message = e?.response?.data?.message;
          if (status === 409) {
            this.$flash_warning(message || 'У вас уже идёт фоновая загрузка аудио');
          } else {
            this.$flash_warning(message || 'Ошибка при сбросе звука открытия двери');
          }
        })
        .finally(() => {
          this.loadingReset = false;
        });
    },
    resetSchedule () {
      this.schedule = {
        useSchedule: false,
        startDate: '',
        endDate: '',
      };
    },
    changeSoundDoor () {
      if (this.$refs.soundDoor.validate()) {
        const { payload, error } = buildSchedulePayload(this.schedule);
        if (error) {
          this.$flash_warning(error);
          return;
        }
        if (this.doorphones.length > 1000) {
          this.$flash_warning('Можно выбрать не более 1000 домофонов. Используйте расширенную страницу.');
          return;
        }
        const formData = new FormData();
        const formDataByModel = {};

        this.doorphones.forEach((doorphone) => {
          const soundModelKey = getOpenDoorSoundModelKey(doorphone.model);
          if (!soundModelKey) {
            return;
          }
          if (!formDataByModel[soundModelKey]) {
            formDataByModel[soundModelKey] = {
              doorphones: [],
              sound: this.soundDoorOpening,
            };
          }
          formDataByModel[soundModelKey].doorphones.push(doorphone.id);
        });

        if (!Object.keys(formDataByModel).length) {
          this.$flash_warning('В выборе нет устройств Beward / Rubetek с поддержкой аудио');
          return;
        }

        Object.keys(formDataByModel).forEach(modelName => {
          const formDataForModel = formDataByModel[modelName];
          formDataForModel.doorphones.forEach((doorphoneId, idx) => {
            formData.append(`${modelName}_doorphones[${idx}]`, doorphoneId);
          });
          formData.append(`${modelName}_sound`, formDataForModel.sound);
        });
        if (payload) {
          formData.append('start_date', payload.start_date);
          formData.append('end_date', payload.end_date);
        }
        this.isLoading = true;
        this.uploadOpenDoorSound(formData)
          .then((res) => {
            this.soundDoorOpening = null;
            this.$refs.soundDoor.resetValidation();
            this.dialogSound = false;

            if (this.schedule && this.schedule.useSchedule) {
              this.updateResult = res || {};
              this.updateResult.message = 'Готово! В данный период загрузится аудиозапись. По окончании периода аудиозапись будет сброшена на стандартное значение.';
              this.dialogResult = true;
            } else {
              this.$flash_success(
                `Задача поставлена в фон${res.mass_upload_id ? ` (${res.mass_upload_id})` : ''}. Прогресс — в колокольчике.`,
              );
            }

            this.resetSchedule();
          })
          .catch((e) => {
            const status = e?.response?.status;
            const message = e?.response?.data?.message;
            if (status === 409) {
              this.$flash_warning(message || 'У вас уже идёт фоновая загрузка аудио');
            } else {
              this.$flash_warning(message || 'Ошибка при смене звука открытия двери');
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
  },
};
</script>
